import { render, staticRenderFns } from "./QueueManage.vue?vue&type=template&id=824aac68&scoped=true"
import script from "./QueueManage.vue?vue&type=script&lang=ts"
export * from "./QueueManage.vue?vue&type=script&lang=ts"
import style0 from "./QueueManage.vue?vue&type=style&index=0&id=824aac68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824aac68",
  null
  
)

export default component.exports